module.exports = __webpack_public_path__ + "img/musas.dbab6225.png";